





























































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import VueLazyload from 'vue-lazyload';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
import _ from 'lodash';

class  PageAisleRequest extends PageRequest{
    keyword:string;
    roomCode:string;
}

@Component
export default class Aisle extends mixins(ListMixin, AbpBase){
    namespace = 'aisle';
    rooms=[];
     isTenant() {
      return this.$store.state.session.tenant != null;
    }
    get store () {
      return this.$store.state.aisle;
    }
   
    //filters
    pagerequest:PageAisleRequest=new PageAisleRequest();
    creationTime:Date[]=[];
    get list(){
      var re = this.store.list;
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var index = 0;
      re.forEach(function(item) {
        item.orderNo = startIndex + index + 1;
        index++;
      });
      return re;
    }
    deleteAisle(row:any) {
    this.$Modal.confirm({
      title: this.L('Tips'),
      content: this.L(`Delete${_.startCase(this.namespace)}Confirm`),
      okText: this.L('Yes'),
      cancelText: this.L('No'),
      onOk: async () => {
        await this.$store.dispatch({
          type: `${this.namespace}/delete`,
          data: {
            id: row.id,
            roomCode :row.roomCode
          }
        })
        await this.getpage();
      }
    })
  }
    async getRooms(){
         await this.$store.dispatch({
                type:'room/getRoomsForSelect',
                data:{ hasAllItem:true}
            }).then(result=>{
                this.rooms = result;
                this.pagerequest.roomCode = result.length === 0 ? "" : result[0].id;
            });
    }
    columns= [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
    },{
        title:Util.L('Room'),
        width:200,
        key:'roomName',
    },{
        title:Util.L('Aisle'),
        width:200,
        key:'id'
    },{
        title:Util.L('Size') +' (m)',
        width:200,
         render:(h:any,params:any)=>{
            return h("span", params.row.length +'x'+params.row.width+'x'+params.row.height );
        }
    },{
        title:Util.L('IndexNo'),
        width:100,
        key:'indexNo'
    },{
        title:Util.L('CreatorUserName'),
        width:150,
        key:'creatorUserName'
    },{
        title:Util.L('CreationTime'),
        key:'creationTime',
        render:(h:any,params:any)=>{
            return h("span", Util.toViewDateString(params.row.creationTime));
        }
    },
    {
        title: this.L('Action'),
        slot: 'action',
        fixed: 'right',
        align: 'center',
        width: 200
    }]
    async created(){
      await this.getRooms();
    }
}
